import { SignedUpLastSyncKey } from "./consts";

export const getLastSync = () =>
  Number.parseInt(sessionStorage.getItem(SignedUpLastSyncKey) ?? "0");

export const setLastSync = (lastSync: number) =>
  sessionStorage.setItem(SignedUpLastSyncKey, `${lastSync}`);
